export const environment = {
  production: true,
  apiUri: 'https://api.ugona.net/api/',
  info: null
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts